import { Injectable, computed, effect, inject, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { TenantDto } from '../api/mhsInternalApiClient';
import { AuthStore } from '../authentication/authStore';
import { TenantService } from '../services/tenant-service';
import {
  STORAGE_BODY_AREAS,
  STORAGE_KEY_COMPANY,
  STORAGE_KEY_RESOURCE_IDENTITY_TYPES,
  STORAGE_KEY_RESOURCE_MED_SPECIALIZATIONS,
  STORAGE_KEY_RESOURCE_MED_TITLES,
  STORAGE_KEY_TENANT,
} from './storage-keys';
import { StorageService } from './storageService';
@Injectable({
  providedIn: 'root',
})
export class UsertStore {
  constructor() {
    effect(() => {
      if (this.userContext() === null) return;
      if (this.tenantService.avilableTenants() === null) return;
      if (this.currentTenant() === null) {
        this.initializeIfNeeded();
      }
    });
  }
  storageService = inject(StorageService);
  tenantService = inject(TenantService);
  auth = inject(AuthStore);
  router = inject(Router);
  readonly _currentTenant = signal<TenantDto | null>(null);
  readonly currentTenant = this._currentTenant.asReadonly();
  readonly currentTenant$ = toObservable(this._currentTenant);

  setCurrentTenant(tenant: TenantDto | null) {
    this.storageService.remove(STORAGE_KEY_COMPANY);
    this.storageService.remove(STORAGE_KEY_RESOURCE_IDENTITY_TYPES);
    this.storageService.remove(STORAGE_KEY_RESOURCE_MED_SPECIALIZATIONS);
    this.storageService.remove(STORAGE_KEY_RESOURCE_MED_TITLES);
    this.storageService.remove(STORAGE_BODY_AREAS);

    this._currentTenant.set(tenant);
    this.storageService.set(STORAGE_KEY_TENANT, JSON.stringify(tenant));
    location.reload();
    //     const url = '/';
    // const navigationResult = this.router
    //   .navigateByUrl('/', { skipLocationChange: true })
    //   .then(() => this.router.navigateByUrl(url));
  }

  initializeIfNeeded() {
    const ctx = this.userContext();
    if (!ctx) return;

    const tenants = ctx.avilableTenants;
    if (!tenants.length) return;

    const current = this._currentTenant();
    if (current) return;

    const storedTenant = this.storageService.get(STORAGE_KEY_TENANT);
    if (storedTenant) {
      this._currentTenant.set(JSON.parse(storedTenant));
    } else {
      this._currentTenant.set(tenants[0]);
    }
  }

  readonly userContext = computed(() => {
    if (this.auth.isAuthenticated().isAuthenticated === false) return null;

    const userData = this.auth.userData();
    const tenants = this.tenantService.avilableTenants();

    if (!userData) return null;

    const userTenants = this.auth.userClaims()['mhs.scm.tenants'];

    if (!userTenants) return null;

    const tenantsArray = JSON.parse(userTenants.replace(/'/g, '"'));
    let filteredTenants = tenants.filter((t) => tenantsArray.includes(t.tenantName));
    const userContext = {
      firstName: userData.userData['mhs.scm.firstname'] ?? '',
      lastName: userData.userData['mhs.scm.lastname'] ?? '',
      tenants: filteredTenants,
      email: userData.userData['email'] ?? '',
      userId: userData.userData['sub'] ?? '',
      avilableTenants: filteredTenants,
      avilableRoles: userData.userData?.role ?? [],
    };
    return userContext;
  });
}
